<template>
  <div v-if="!$root.isMobile" class="col-md-6 col-md-offset-3">
    <div class="shadow-box thumbnail-box">
      <div :class="`videoPlayer ${ playVideo ? 'open' : '' }`">
        <iframe id="ytplayer" type="text/html" width="1264" height="711" :src="`https://www.youtube.com/embed/${videoToPlay.youtube_embed_id}?autoplay=1&rel=0&color=white`" frameborder="0" allowfullscreen v-if="videoToPlay.youtube_embed_id" referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>
      <div v-show="playVideo">
        <div class="description">
          <strong>{{ videoToPlay.title }}</strong><br>
          {{ videoToPlay.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Renders the video component.
 * Associated files: 'videoList.vue', 'videoSearch.vue', 'video.js' and 'videos.blade.php'
 * @displayName Video Player
 */

export default {
  name: 'video-player',
  parent: 'video-content',

  props: {
    playVideo: Boolean,
    videoToPlay: Object
  },
}
</script>

<style lang="scss" scoped>
  .col-md-6, .col-md-offset-3{
    margin-bottom: 25px;
  }
  .description {
    padding: 10px;
    text-align: center;
  }

  .thumbnail-box {
    padding: 0;
  }
</style>